import React from 'react';
import { Box, Card, CardContent, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { BarChart } from '@mui/x-charts/BarChart';
import { format, parse, isValid } from 'date-fns';
import { Metrics } from './types';

interface TimeSeriesChartProps {
  metrics: Metrics;
  bucket: 'week' | 'month';
  onBucketChange: (b: 'week' | 'month') => void;
}

export const TimeSeriesChart: React.FC<TimeSeriesChartProps> = ({ metrics, bucket, onBucketChange }) => {
  const labels = metrics.series.map((p) => {
    const d = parse(p.bucket, 'yyyy-MM-dd', new Date());
    if (!isValid(d)) return p.bucket;
    return bucket === 'month' ? format(d, 'MMM yyyy') : format(d, 'MMM d');
  });

  return (
    <Card variant="outlined">
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            Versions over time {bucket === 'week' ? '(by week)' : '(by month)'}
          </Typography>
          <ToggleButtonGroup
            size="small"
            exclusive
            value={bucket}
            onChange={(_e, v) => { if (v) onBucketChange(v); }}
          >
            <ToggleButton value="week">Weekly</ToggleButton>
            <ToggleButton value="month">Monthly</ToggleButton>
          </ToggleButtonGroup>
        </Box>
        {metrics.series.length === 0 ? (
          <Typography variant="body2" color="text.secondary" sx={{ py: 6, textAlign: 'center' }}>
            No renders in this range.
          </Typography>
        ) : (
          <BarChart
            height={280}
            xAxis={[{ scaleType: 'band', data: labels }]}
            series={[
              { data: metrics.series.map((p) => p.billable), label: 'Billable', stack: 'total', color: '#2e7d32' },
              { data: metrics.series.map((p) => p.reruns), label: 'Reruns', stack: 'total', color: '#bdbdbd' },
            ]}
            slotProps={{ legend: { position: { vertical: 'top', horizontal: 'end' } } }}
          />
        )}
      </CardContent>
    </Card>
  );
};
